// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.snt-salepage-list[data-v-2199ca93] {\n  margin: 0 -8px;\n}\n.snt-salepage-search[data-v-2199ca93] {\n  width: 400px;\n}\n.snt-salepage-stock[data-v-2199ca93] {\n  width: 300px;\n}\n.no-data[data-v-2199ca93] {\n  text-align: center;\n  padding: 7rem 0;\n  display: flex;\n  flex-direction: column;\n}\n", ""]);
// Exports
module.exports = exports;
